import Select from '@material-ui/core/Select';
import { Modal } from '@sapiens/insured-component-library';
import { MediaBreakpoints } from 'common/utils/helpers/theme.helpers';
import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
interface DescriptionDropdownItemProps {
  isFocused: boolean;
}

export const SelectPolicyModal = styled(Modal)`
  .rc-dialog-content {
    width: 1015.94px;
    min-height: 500px;
    padding: 40px;
    overflow: auto;
  }
  .rc-dialog-content .rc-dialog-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    overflow: visible;

    ::-webkit-scrollbar {
      width: 12px !important;
    }
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.palette.neutral.white};
      border-radius: 6px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.palette.product.F999};
      border-radius: 20px;
      border: 3px solid ${({ theme }) => theme.palette.neutral.white};
    }
  }
  ${MediaBreakpoints.down('md')} {
    .rc-dialog-content {
      width: 90% !important;
      padding: 40px 8px;
      max-height: 80%;
    }
  }
`;

export const SelectPolicyHeader = styled.div`
  font-family: 'Eina 03';
  font-size: 21px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  margin: 0 auto;

  ${MediaBreakpoints.down('md')} {
    width: 254px;
    font-size: 16px;
  }
`;

export const SelectPolicyProductsContainer = styled.div`
  margin: 30px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: center;
  align-content: flex-start;
  width: 100%;

  ${MediaBreakpoints.down('md')} {
    max-height: 453px;
    overflow: auto;
    margin: 16px 0;
    padding: 5px 0;
  }
`;

export const HorizontalLine = styled.hr`
  width: 95%;
  border: 1px solid #dee3e6;
`;

export const SelectPolicyDescription = styled.div`
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  row-gap: 12px;

  ${MediaBreakpoints.down('md')} {
    margin: 16px 0;
  }
`;

export const PolicyDescriptionHeader = styled.div`
  font-family: 'Eina 03';
  font-size: 21px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;

  ${MediaBreakpoints.down('md')} {
    font-size: 16px;
  }
`;

export const PolicyDescriptionHelpSection = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  column-gap: 11px;
`;

export const PolicyDescriptionHelpText = styled.div`
  font-family: 'Eina 03';
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #7f7f7f;
`;

export const TooltipIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const PolicyDescriptionTooltipSection = styled.div`
  margin-top: 16px;
  width: 734px;
  padding: 5px 10px;
  border-radius: 4px;
  opacity: 0px;
  background: #f2fbff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  ${MediaBreakpoints.down('md')} {
    margin: 16px auto;
    width: 100%;
  }
`;

export const TooltipCloseButton = styled.div`
  cursor: pointer;
  align-self: flex-end;
`;

export const TooltipText = styled.div`
  font-family: 'Eina 03';
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  color: #7f7f7f;
  margin: 5px 30px 22px 30px;

  ${MediaBreakpoints.down('md')} {
    font-size: 14px;
  }
`;

export const PolicyDescriptionDropdownSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 741.58px;
  margin: 0 auto;
  box-sizing: border-box;

  ${MediaBreakpoints.down('md')} {
    width: 100%;
    padding: 4px;
    align-items: stretch;
  }
`;

export const DescriptionDropdownLabel = styled.label`
  font-family: 'Eina 03';
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  align-self: flex-start;
  margin-bottom: 8px;

  ${MediaBreakpoints.down('md')} {
    font-size: 12px;
  }
`;

export const DescriptionDropdown = styled(Select)`
  box-sizing: border-box !important;
  background: none;
  font-family: 'Eina 03' !important;
  height: 40px !important;
  border-radius: 6px !important;
  justify-content: flex-start !important;
  box-shadow: none !important;
  border: 1px solid #7f7f7f !important;
  padding: 8px !important;
  min-width: 100% !important;

  & :focus {
    background: white !important;
  }
`;

export const DescriptionDropdownItem = styled(MenuItem)<DescriptionDropdownItemProps>`
  font-family: 'Eina 03' !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 22px !important;
  text-align: left !important;
  padding: 6px !important;
  white-space: normal !important;
  cursor: pointer;
  background-color: ${({ isFocused, theme }) => (isFocused ? theme.palette.light.N20 : 'white')};

  &:hover {
    background-color: ${({ theme }) => theme.palette.light.N20};
  }
`;
export const SelectPolicyButtonsSection = styled.div`
  margin-top: 30px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  column-gap: 20px;

  ${MediaBreakpoints.down('md')} {
    column-gap: 10px;
    margin-top: 24px;
  }
`;

export const SelectPolicyCancelButton = styled.button`
  width: 87px;
  height: 40px;
  padding: 10px 12px 10px 12px;
  border-radius: 6px;
  border: none;
  opacity: 0px;
  background: #ebeef0;
  box-shadow: 0px 0px 1px 0px #00283b4f, 0px 1px 1px 0px #00283b40;

  font-family: 'Eina 03';
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  cursor: pointer;

  ${MediaBreakpoints.down('md')} {
    width: fit-content;
  }
`;

export const SelectPolicyProceedButton = styled.button<{ $enableProceed: boolean }>`
    height: 40px;
    padding: 10px 12px 10px 12px;
    border-radius: 6px;
    border: none;
    background: ${($props) => ($props.$enableProceed ? '#13544E;' : 'grey;')}
    box-shadow: 0px 0px 1px 0px #00283B4F,
    0px 1px 1px 0px #00283B40;
    font-family: 'Eina 03';
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
    cursor: ${($props) => ($props.$enableProceed ? 'pointer;' : 'auto;')}

    ${MediaBreakpoints.down('md')} {
        width: fit-content;
    }
`;
